const isPlainObject = (value) =>
  Object.prototype.toString.call(value) === "[object Object]";

const valuesEqual = (a, b) => {
  if (Array.isArray(a) || Array.isArray(b)) {
    return JSON.stringify(a ?? []) === JSON.stringify(b ?? []);
  }

  if (isPlainObject(a) || isPlainObject(b)) {
    return JSON.stringify(a ?? {}) === JSON.stringify(b ?? {});
  }

  return a === b;
};

export const getDeepDifferences = (oldObj, newObj, path = "") => {
  const changes = [];

  const keys = new Set([
    ...Object.keys(oldObj || {}),
    ...Object.keys(newObj || {}),
  ]);

  for (const key of keys) {
    const oldValue = oldObj?.[key];
    const newValue = newObj?.[key];
    const nextPath = path ? `${path}.${key}` : key;

    const bothObjects = isPlainObject(oldValue) && isPlainObject(newValue);

    if (bothObjects) {
      changes.push(...getDeepDifferences(oldValue, newValue, nextPath));
      continue;
    }

    if (!valuesEqual(oldValue, newValue)) {
      changes.push({
        field: nextPath,
        oldValue: oldValue ?? null,
        newValue: newValue ?? null,
      });
    }
  }

  return changes;
};

export const getEditAdviserAuditChanges = ({ originalForm, updatedForm }) => {
  const sections = [
    "adviserDoc",
    "personalDetails",
    "applicationDetails",
    "nextOfKinDetails",
  ];

  return sections.flatMap((section) =>
    getDeepDifferences(
      originalForm?.[section] || {},
      updatedForm?.[section] || {},
      section,
    ).map((change) => ({
      ...change,
      section,
    })),
  );
};

export const formatAuditFieldShort = (field) => {
  if (!field) return "-";

  const lastPart = String(field).split(".").pop();

  // Optional overrides (only where needed)
  const overrides = {
    dob: "Date of Birth",
    fcaNumber: "FCA Number",
    regulatoryText: "Regulatory Wording",
    ARBusinessAreas: "AR Business Permissions",
    businessAreas: "Business Permissions",
  };

  if (overrides[lastPart]) return overrides[lastPart];

  return (
    lastPart
      // handle array index
      .replace(/\[(\d+)\]/g, " $1")

      // split camelCase
      .replace(/([a-z])([A-Z])/g, "$1 $2")

      // capitalise each word
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(" ")
      .trim()
  );
};
// export const formatAuditField = (field) => {
//   if (!field) return "-";

//   return String(field)
//     .replace(/\[(\d+)\]/g, " $1")
//     .replace(/\.(\d+)/g, " $1")
//     .replace(/\./g, " / ")
//     .replace(/([a-z])([A-Z])/g, "$1 $2")
//     .replace(/\bforename\b/i, "First Name")
//     .replace(/\bsurname\b/i, "Last Name")
//     .replace(/\bdob\b/i, "Date of Birth")
//     .replace(/\bfcaNumber\b/i, "FCA Number")
//     .replace(/\btradingStyles\b/i, "Trading Styles")
//     .replace(/\btradingStyle\b/i, "Trading Style")
//     .replace(/\btradingName\b/i, "Trading Name")
//     .replace(/\bregulatoryText\b/i, "Regulatory Wording")
//     .replace(/\bemailAddress\b/i, "Email Address")
//     .replace(/\bmobileTelephone\b/i, "Mobile Telephone")
//     .replace(/\bofficeTelephone\b/i, "Office Telephone")
//     .replace(/\bhomeTelephone\b/i, "Home Telephone")
//     .replace(/\bARBusinessAreas\b/g, "AR Business Permissions")
//     .replace(/\bbusinessAreas\b/g, "Business Permissions")
//     .replace(/\bapplyingAs\b/i, "Applying As")
//     .replace(/\bapplyingToJoin\b/i, "Applying To Join")
//     .replace(/\bcurrentAddress\b/i, "Current Address")
//     .replace(/\bcurrentTown\b/i, "Current Town")
//     .replace(/\bcurrentCounty\b/i, "Current County")
//     .replace(/\bcurrentPostcode\b/i, "Current Postcode")
//     .replace(/\bmovingInDate\b/i, "Moving In Date")
//     .replace(/\bnationalityAtBirth\b/i, "Nationality At Birth")
//     .replace(/\btownOfBirth\b/i, "Town Of Birth")
//     .replace(/\bcountryOfBirth\b/i, "Country Of Birth")
//     .replace(/\bnameChangeDate\b/i, "Name Change Date")
//     .replace(/\bdurationInUk\b/i, "Lived In UK Since")
//     .replace(/\bnextOfKinDetails\b/i, "Next Of Kin")
//     .replace(/\bpersonalDetails\b/i, "Personal Details")
//     .replace(/\bapplicationDetails\b/i, "Application Details")
//     .replace(/\badviserDoc\b/i, "Adviser Details")
//     .trim();
// };